import React from 'react';
import { GlassGradient, GlassPanel, Handle, BattenteTriangleFill, AntaRibaltaFill, VasistasFill, FixedMark, SlidingArrow, BilicoH, BilicoV } from './primitives';

export const entryDoor = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_ed" />
    <GlassPanel x={8} y={8} w={54} h={104} gradId="g_ed" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const entryDoorSingle = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_eds" />
    <GlassPanel x={8} y={8} w={54} h={104} gradId="g_eds" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const entryDoorFissoSx = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_edfs" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_edfs" />
    <FixedMark x={8} y={8} w={25} h={104} />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_edfs" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const entryDoorFissoDx = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_edfd" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_edfd" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_edfd" />
    <FixedMark x={67} y={8} w={25} h={104} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const entryDoorNoSopra = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_edns" />
    <GlassPanel x={8} y={8} w={54} h={104} gradId="g_edns" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const entryDoorConSopra = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_edcs" />
    <GlassPanel x={8} y={8} w={54} h={18} gradId="g_edcs" />
    <GlassPanel x={8} y={30} w={54} h={82} gradId="g_edcs" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={8} y1={28} x2={62} y2={28} stroke="#222" strokeWidth="0.8" />
  </svg>
);

export const entryDoorFissoSxNoSopra = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_efsns" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_efsns" />
    <FixedMark x={8} y={8} w={25} h={104} />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_efsns" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const entryDoorFissoSxConSopra = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_efscs" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_efscs" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={25} h={82} gradId="g_efscs" />
    <FixedMark x={8} y={30} w={25} h={82} />
    <GlassPanel x={37} y={30} w={55} h={82} gradId="g_efscs" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={28} x2={37} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const entryDoorFissoDxNoSopra = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_efdns" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_efdns" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_efdns" />
    <FixedMark x={67} y={8} w={25} h={104} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const entryDoorFissoDxConSopra = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_efdcs" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_efdcs" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={55} h={82} gradId="g_efdcs" />
    <GlassPanel x={67} y={30} w={25} h={82} gradId="g_efdcs" />
    <FixedMark x={67} y={30} w={25} h={82} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={28} x2={63} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const open_porta_batt_dx_est = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_pbde" />
    <GlassPanel x={8} y={8} w={54} h={104} gradId="g_pbde" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={8} y={8} w={54} h={104} side="right" />
  </svg>
);

export const open_porta_batt_sx_est = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_pbse" />
    <GlassPanel x={8} y={8} w={54} h={104} gradId="g_pbse" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={8} y={8} w={54} h={104} side="left" />
  </svg>
);

export const open_porta_batt_dx_int = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_pbdi" />
    <GlassPanel x={8} y={8} w={54} h={104} gradId="g_pbdi" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    {/* Stesso verso di DX esterno ma tratteggiato: cerniera DX, apice a SX */}
    <polygon points="8,60 62,8 62,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_batt_sx_int = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_pbsi" />
    <GlassPanel x={8} y={8} w={54} h={104} gradId="g_pbsi" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    {/* Stesso verso di SX esterno ma tratteggiato: cerniera SX, apice a DX */}
    <polygon points="62,60 8,8 8,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_fsx_batt_dx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfsd1" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_pfsd1" />
    <FixedMark x={8} y={8} w={25} h={104} />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_pfsd1" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={37} y={8} w={55} h={104} side="right" />
  </svg>
);

export const open_porta_fsx_batt_sx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfsd2" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_pfsd2" />
    <FixedMark x={8} y={8} w={25} h={104} />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_pfsd2" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={37} y={8} w={55} h={104} side="left" />
  </svg>
);

export const open_porta_fsx_batt_dx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfsd3" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_pfsd3" />
    <FixedMark x={8} y={8} w={25} h={104} />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_pfsd3" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="37,60 92,8 92,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_fsx_batt_sx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfsd4" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_pfsd4" />
    <FixedMark x={8} y={8} w={25} h={104} />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_pfsd4" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="92,60 37,8 37,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_fdx_batt_dx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfdd1" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_pfdd1" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_pfdd1" />
    <FixedMark x={67} y={8} w={25} h={104} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={8} y={8} w={55} h={104} side="right" />
  </svg>
);

export const open_porta_fdx_batt_sx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfdd2" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_pfdd2" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_pfdd2" />
    <FixedMark x={67} y={8} w={25} h={104} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={8} y={8} w={55} h={104} side="left" />
  </svg>
);

export const open_porta_fdx_batt_dx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfdd3" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_pfdd3" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_pfdd3" />
    <FixedMark x={67} y={8} w={25} h={104} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="8,60 63,8 63,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_fdx_batt_sx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfdd4" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_pfdd4" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_pfdd4" />
    <FixedMark x={67} y={8} w={25} h={104} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="63,60 8,8 8,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const entryDoorSemifissoSx = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_edssx" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_edssx" />
    <BattenteTriangleFill x={8} y={8} w={25} h={104} side="left" />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_edssx" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const entryDoorSemifissoDx = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_edsdx" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_edsdx" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_edsdx" />
    <BattenteTriangleFill x={67} y={8} w={25} h={104} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const entryDoorSemifissoSxNoSopra = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfsnos" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_sfsnos" />
    <BattenteTriangleFill x={8} y={8} w={25} h={104} side="left" />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_sfsnos" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const entryDoorSemifissoSxConSopra = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfscos" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_sfscos" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={25} h={82} gradId="g_sfscos" />
    <BattenteTriangleFill x={8} y={30} w={25} h={82} side="left" />
    <GlassPanel x={37} y={30} w={55} h={82} gradId="g_sfscos" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={28} x2={37} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const entryDoorSemifissoDxNoSopra = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfdnos" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_sfdnos" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_sfdnos" />
    <BattenteTriangleFill x={67} y={8} w={25} h={104} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const entryDoorSemifissoDxConSopra = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfdcos" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_sfdcos" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={55} h={82} gradId="g_sfdcos" />
    <GlassPanel x={67} y={30} w={25} h={82} gradId="g_sfdcos" />
    <BattenteTriangleFill x={67} y={30} w={25} h={82} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={28} x2={63} y2={112} stroke="#222" strokeWidth="1" />
  </svg>
);

export const open_porta_sfsx_batt_dx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfs1" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_sfs1" />
    <BattenteTriangleFill x={8} y={8} w={25} h={104} side="left" />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_sfs1" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={37} y={8} w={55} h={104} side="right" />
  </svg>
);

export const open_porta_sfsx_batt_sx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfs2" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_sfs2" />
    <BattenteTriangleFill x={8} y={8} w={25} h={104} side="left" />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_sfs2" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={37} y={8} w={55} h={104} side="left" />
  </svg>
);

export const open_porta_sfsx_batt_dx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfs3" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_sfs3" />
    <BattenteTriangleFill x={8} y={8} w={25} h={104} side="left" />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_sfs3" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="37,60 92,8 92,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_sfsx_batt_sx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfs4" />
    <GlassPanel x={8} y={8} w={25} h={104} gradId="g_sfs4" />
    <BattenteTriangleFill x={8} y={8} w={25} h={104} side="left" />
    <GlassPanel x={37} y={8} w={55} h={104} gradId="g_sfs4" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={8} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="92,60 37,8 37,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_sfsx_s_batt_dx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfss1" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_sfss1" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={25} h={82} gradId="g_sfss1" />
    <BattenteTriangleFill x={8} y={30} w={25} h={82} side="left" />
    <GlassPanel x={37} y={30} w={55} h={82} gradId="g_sfss1" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={28} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={37} y={30} w={55} h={82} side="right" />
  </svg>
);

export const open_porta_sfsx_s_batt_sx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfss2" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_sfss2" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={25} h={82} gradId="g_sfss2" />
    <BattenteTriangleFill x={8} y={30} w={25} h={82} side="left" />
    <GlassPanel x={37} y={30} w={55} h={82} gradId="g_sfss2" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={28} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={37} y={30} w={55} h={82} side="left" />
  </svg>
);

export const open_porta_sfsx_s_batt_dx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfss3" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_sfss3" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={25} h={82} gradId="g_sfss3" />
    <BattenteTriangleFill x={8} y={30} w={25} h={82} side="left" />
    <GlassPanel x={37} y={30} w={55} h={82} gradId="g_sfss3" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={28} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="37,71 92,30 92,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_sfsx_s_batt_sx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfss4" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_sfss4" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={25} h={82} gradId="g_sfss4" />
    <BattenteTriangleFill x={8} y={30} w={25} h={82} side="left" />
    <GlassPanel x={37} y={30} w={55} h={82} gradId="g_sfss4" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={28} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="92,71 37,30 37,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_sfdx_batt_dx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfd1" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_sfd1" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_sfd1" />
    <BattenteTriangleFill x={67} y={8} w={25} h={104} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={8} y={8} w={55} h={104} side="right" />
  </svg>
);

export const open_porta_sfdx_batt_sx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfd2" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_sfd2" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_sfd2" />
    <BattenteTriangleFill x={67} y={8} w={25} h={104} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={8} y={8} w={55} h={104} side="left" />
  </svg>
);

export const open_porta_sfdx_batt_dx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfd3" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_sfd3" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_sfd3" />
    <BattenteTriangleFill x={67} y={8} w={25} h={104} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="8,60 63,8 63,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_sfdx_batt_sx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfd4" />
    <GlassPanel x={8} y={8} w={55} h={104} gradId="g_sfd4" />
    <GlassPanel x={67} y={8} w={25} h={104} gradId="g_sfd4" />
    <BattenteTriangleFill x={67} y={8} w={25} h={104} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={8} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="63,60 8,8 8,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_sfdx_s_batt_dx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfds1" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_sfds1" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={55} h={82} gradId="g_sfds1" />
    <GlassPanel x={67} y={30} w={25} h={82} gradId="g_sfds1" />
    <BattenteTriangleFill x={67} y={30} w={25} h={82} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={28} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={8} y={30} w={55} h={82} side="right" />
  </svg>
);

export const open_porta_sfdx_s_batt_sx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfds2" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_sfds2" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={55} h={82} gradId="g_sfds2" />
    <GlassPanel x={67} y={30} w={25} h={82} gradId="g_sfds2" />
    <BattenteTriangleFill x={67} y={30} w={25} h={82} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={28} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={8} y={30} w={55} h={82} side="left" />
  </svg>
);

export const open_porta_sfdx_s_batt_dx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfds3" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_sfds3" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={55} h={82} gradId="g_sfds3" />
    <GlassPanel x={67} y={30} w={25} h={82} gradId="g_sfds3" />
    <BattenteTriangleFill x={67} y={30} w={25} h={82} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={28} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="8,71 63,30 63,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_sfdx_s_batt_sx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_sfds4" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_sfds4" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={55} h={82} gradId="g_sfds4" />
    <GlassPanel x={67} y={30} w={25} h={82} gradId="g_sfds4" />
    <BattenteTriangleFill x={67} y={30} w={25} h={82} side="right" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={28} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="63,71 8,30 8,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_s_batt_dx_est = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_psde" />
    <GlassPanel x={8} y={8} w={54} h={18} gradId="g_psde" />
    <GlassPanel x={8} y={30} w={54} h={82} gradId="g_psde" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={8} y1={28} x2={62} y2={28} stroke="#222" strokeWidth="0.8" />
    <BattenteTriangleFill x={8} y={30} w={54} h={82} side="right" />
  </svg>
);

export const open_porta_s_batt_sx_est = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_psse" />
    <GlassPanel x={8} y={8} w={54} h={18} gradId="g_psse" />
    <GlassPanel x={8} y={30} w={54} h={82} gradId="g_psse" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={8} y1={28} x2={62} y2={28} stroke="#222" strokeWidth="0.8" />
    <BattenteTriangleFill x={8} y={30} w={54} h={82} side="left" />
  </svg>
);

export const open_porta_s_batt_dx_int = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_psdi" />
    <GlassPanel x={8} y={8} w={54} h={18} gradId="g_psdi" />
    <GlassPanel x={8} y={30} w={54} h={82} gradId="g_psdi" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={8} y1={28} x2={62} y2={28} stroke="#222" strokeWidth="0.8" />
    <polygon points="8,71 62,30 62,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_s_batt_sx_int = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <GlassGradient id="g_pssi" />
    <GlassPanel x={8} y={8} w={54} h={18} gradId="g_pssi" />
    <GlassPanel x={8} y={30} w={54} h={82} gradId="g_pssi" />
    <rect x={4} y={4} width={62} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={8} y1={28} x2={62} y2={28} stroke="#222" strokeWidth="0.8" />
    <polygon points="62,71 8,30 8,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_fsx_s_batt_dx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfss1" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_pfss1" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={25} h={82} gradId="g_pfss1" />
    <FixedMark x={8} y={30} w={25} h={82} />
    <GlassPanel x={37} y={30} w={55} h={82} gradId="g_pfss1" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={28} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={37} y={30} w={55} h={82} side="right" />
  </svg>
);

export const open_porta_fsx_s_batt_sx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfss2" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_pfss2" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={25} h={82} gradId="g_pfss2" />
    <FixedMark x={8} y={30} w={25} h={82} />
    <GlassPanel x={37} y={30} w={55} h={82} gradId="g_pfss2" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={28} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={37} y={30} w={55} h={82} side="left" />
  </svg>
);

export const open_porta_fsx_s_batt_dx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfss3" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_pfss3" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={25} h={82} gradId="g_pfss3" />
    <FixedMark x={8} y={30} w={25} h={82} />
    <GlassPanel x={37} y={30} w={55} h={82} gradId="g_pfss3" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={28} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="37,71 92,30 92,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_fsx_s_batt_sx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfss4" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_pfss4" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={25} h={82} gradId="g_pfss4" />
    <FixedMark x={8} y={30} w={25} h={82} />
    <GlassPanel x={37} y={30} w={55} h={82} gradId="g_pfss4" />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={37} y1={28} x2={37} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="92,71 37,30 37,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_fdx_s_batt_dx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfds1" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_pfds1" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={55} h={82} gradId="g_pfds1" />
    <GlassPanel x={67} y={30} w={25} h={82} gradId="g_pfds1" />
    <FixedMark x={67} y={30} w={25} h={82} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={28} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={8} y={30} w={55} h={82} side="right" />
  </svg>
);

export const open_porta_fdx_s_batt_sx_est = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfds2" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_pfds2" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={55} h={82} gradId="g_pfds2" />
    <GlassPanel x={67} y={30} w={25} h={82} gradId="g_pfds2" />
    <FixedMark x={67} y={30} w={25} h={82} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={28} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <BattenteTriangleFill x={8} y={30} w={55} h={82} side="left" />
  </svg>
);

export const open_porta_fdx_s_batt_dx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfds3" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_pfds3" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={55} h={82} gradId="g_pfds3" />
    <GlassPanel x={67} y={30} w={25} h={82} gradId="g_pfds3" />
    <FixedMark x={67} y={30} w={25} h={82} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={28} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="8,71 63,30 63,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_porta_fdx_s_batt_sx_int = () => (
  <svg viewBox="0 0 100 120" className="w-full h-full">
    <GlassGradient id="g_pfds4" />
    <GlassPanel x={8} y={8} w={84} h={18} gradId="g_pfds4" />
    <line x1={8} y1={28} x2={92} y2={28} stroke="#222" strokeWidth="0.8" />
    <GlassPanel x={8} y={30} w={55} h={82} gradId="g_pfds4" />
    <GlassPanel x={67} y={30} w={25} h={82} gradId="g_pfds4" />
    <FixedMark x={67} y={30} w={25} h={82} />
    <rect x={4} y={4} width={92} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={63} y1={28} x2={63} y2={112} stroke="#222" strokeWidth="1" />
    <polygon points="63,71 8,30 8,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

